import { gql } from "@apollo/client";

export const getDowntimeSummaryByFailureTypeCorporateDashboard = gql`
    query getDowntimeSummaryByFailureTypeCorporateDashboardNew(
        $args: get_downtime_summary_totals_by_failure_type_corporation_args!
    ) {
        downtimeSummary: get_downtime_summary_totals_by_failure_type_corporation(args: $args) {
            failure_type_id
            corporate_id
            total_seconds
            total_occurrences
            failure_type {
                failure_type_id
                name
                color_code
                is_location_specific
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryByFailureTypeCorporateDashboardResponse {
    failure_type_id: number;
    corporate_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_type: {
        failure_type_id: number;
        name: string;
        color_code: string;
        is_location_specific: boolean;
        default_failure_type_translations: {
            failure_type_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummaryByFailureCodeCorporateDashboardFiltered = gql`
    query getDowntimeSummaryByFailureCodeCorporateDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_code_corporation_args!
        $where: event_failure_code_summary_totals_corporation_bool_exp
    ) {
        downtimeSummary: get_downtime_summary_totals_by_failure_code_corporation(args: $args, where: $where) {
            failure_code_id
            corporate_id
            total_seconds
            total_occurrences
            failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
                failure_type {
                    failure_type_id
                    color_code
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryByFailureCodeCorporateDashboardResponse {
    failure_code_id: number;
    corporate_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_code: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
        failure_type: {
            failure_type_id: number;
            color_code: string;
        };
    };
}

export const getDowntimeSummaryBySecondaryFailureCodeCorporateDashboardFiltered = gql`
    query getDowntimeSummaryBySecondaryFailureCodeCorporateDashboardFiltered(
        $args: get_downtime_summary_totals_by_sec_failure_code_corporation_args!
    ) {
        downtimeSummary: get_downtime_summary_totals_by_sec_failure_code_corporation(args: $args) {
            secondary_failure_code_id
            corporate_id
            total_seconds
            total_occurrences
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryBySecondaryFailureCodeCorporateDashboardResponse {
    secondary_failure_code_id: number;
    corporate_id: number;
    total_seconds: number;
    total_occurrences: number;
    failure_data: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummarySecondaryFailureCodeMillDashboard = gql`
    query getDowntimeSummarySecondaryFailureCodeMillDashboard(
        $where: event_secondary_failure_code_summary_totals_per_mc_bool_exp
        $start_date: timestamptz!
        $end_date: timestamptz!
    ) {
        downtimes: get_downtime_summary_totals_by_secondary_failure_code(
            args: { start_date: $start_date, end_date: $end_date }
            where: $where
        ) {
            total_seconds
            total_occurrences
            failure_data: secondary_failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDowntimeSummaryFailureTypeByMillsCorporateDashboardFiltered = gql`
    query getDowntimeSummaryFailureTypeByMillsCorporateDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_type_by_mill_corporation_args!
        $trailingArgs: get_downtime_summary_totals_by_failure_type_by_mill_corporation_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_type_by_mill_corporation(args: $args) {
            mill_id
            failure_type_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_failure_type_by_mill_corporation(args: $trailingArgs) {
            mill_id
            failure_type_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryFailureTypeByMillsCorporateDashboardFilteredResponse {
    mill_id: number;
    failure_type_id: number;
    total_seconds: number;
    total_occurrences: number;
    mill: {
        mill_id: number;
        name: string;
    };
    failure_type: {
        failure_type_id: number;
        color_code: string;
        name: string;
        default_failure_type_translations: {
            failure_type_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummaryFailureCodeByMillsCorporateDashboardFiltered = gql`
    query getDowntimeSummaryFailureCodeByMillsCorporateDashboardFiltered(
        $args: get_downtime_summary_totals_by_failure_code_by_mill_corporation_args!
        $trailingArgs: get_downtime_summary_totals_by_failure_code_by_mill_corporation_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_failure_code_by_mill_corporation(args: $args) {
            mill_id
            failure_code_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_failure_code_by_mill_corporation(args: $trailingArgs) {
            mill_id
            failure_code_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;

export interface IGetDowntimeSummaryFailureCodeByMillsCorporateDashboardFilteredResponse {
    mill_id: number;
    failure_code_id: number;
    total_seconds: number;
    total_occurrences: number;
    mill: {
        mill_id: number;
        name: string;
    };
    failure_data: {
        failure_code_id: number;
        name: string;
        default_failure_code_translations: {
            failure_code_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
}

export const getDowntimeSummarySecondaryFailureCodeByMillsCorporateDashboardFiltered = gql`
    query getDowntimeSummarySecondaryFailureCodeByMillsCorporateDashboardFiltered(
        $args: get_downtime_summary_totals_by_secondary_failure_code_by_mill_c_args!
        $trailingArgs: get_downtime_summary_totals_by_secondary_failure_code_by_mill_c_args!
    ) {
        baseDowntimes: get_downtime_summary_totals_by_secondary_failure_code_by_mill_c(args: $args) {
            mill_id
            failure_code_id: secondary_failure_code_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
        trailingTrendDowntimes: get_downtime_summary_totals_by_secondary_failure_code_by_mill_c(args: $trailingArgs) {
            mill_id
            failure_code_id: secondary_failure_code_id
            total_seconds
            total_occurrences
            mill {
                mill_id
                name
            }
            failure_data: failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
        }
    }
`;
